import { Center, Container, Text } from '@mantine/core';

export function NotFoundPage(): JSX.Element {
    return (
        <Container px="md" py="lg">
            <Center mih="50vh">
                <Text c="dimmed">404</Text>
            </Center>
        </Container>
    );
}
